import { render, staticRenderFns } from "./enMaterialLibraryClass.vue?vue&type=template&id=36f80f7e&scoped=true"
import script from "./enMaterialLibraryClass.vue?vue&type=script&lang=js"
export * from "./enMaterialLibraryClass.vue?vue&type=script&lang=js"
import style0 from "./enMaterialLibraryClass.vue?vue&type=style&index=0&id=36f80f7e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "36f80f7e",
  null
  
)

export default component.exports